var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loadingTask || !_vm.task)?_c('task-loading-container',{attrs:{"task-id":_vm.taskId}}):_c('task-container',{attrs:{"userInfo":_vm.userInfo,"task":_vm.task,"taskBar":false,"showNav":false},on:{"taskSelected":function($event){return _vm.$emit('taskSelected', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }